import { useTranslation } from '@clavian/i18n/react';
import { Link } from '@tanstack/react-router';

import { HQ_PATHS } from './paths';

/** A page the HQ console does not have: the console's words, and the way back to HQ's front page. */
export function HqNotFound() {
  const { t } = useTranslation('console');
  const { t: hq } = useTranslation('hq');
  return (
    <main className="console-centred" id="console-main">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <p>
        <Link to={HQ_PATHS.home}>{hq('notFound.home')}</Link>
      </p>
    </main>
  );
}
